import { render, staticRenderFns } from "./demo2.vue?vue&type=template&id=29bd02c8&"
import script from "./demo2.vue?vue&type=script&lang=ts&"
export * from "./demo2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports